import { CheckCircle, X, AlertTriangle } from 'lucide-react';

interface AnswerOptionButtonProps {
  choice: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function AnswerOptionButton({
  choice,
  isSelected,
  onClick,
  disabled = false,
  size = 'md',
}: AnswerOptionButtonProps) {
  // Determine styling based on choice
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-600';
  let iconColor = 'text-gray-500';
  let borderStyle = isSelected ? 'border-2' : 'border';
  let borderColor = 'border-gray-300';
  let icon = <CheckCircle className="h-5 w-5" />;

  // Apply special styling for Yes/No/N/A
  if (choice === 'Yes') {
    bgColor = isSelected ? 'bg-green-100' : 'bg-gray-100';
    textColor = isSelected ? 'text-green-600' : 'text-gray-500';
    borderColor = isSelected ? 'border-green-600' : 'border-gray-300';
    icon = <CheckCircle className="h-5 w-5" />;
  } else if (choice === 'No') {
    bgColor = isSelected ? 'bg-red-100' : 'bg-gray-100';
    textColor = isSelected ? 'text-red-600' : 'text-gray-500';
    borderColor = isSelected ? 'border-red-600' : 'border-gray-300';
    icon = <X className="h-5 w-5" />;
  } else if (choice === 'N/A' || choice === 'Not Applicable') {
    bgColor = isSelected ? 'bg-[#f8f3e9]' : 'bg-gray-100';
    textColor = isSelected ? 'text-[#b89256]' : 'text-gray-500';
    borderColor = isSelected ? 'border-[#b89256]' : 'border-gray-300';
    icon = <AlertTriangle className="h-5 w-5" />;
  }

  // Size variations
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center justify-center ${sizeClasses[size]} rounded-full ${bgColor} ${textColor} ${borderStyle} ${borderColor} ${
        disabled ? 'cursor-not-allowed opacity-50' : ''
      }`}
    >
      {icon}
    </button>
  );
}